import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import req from 'utils/req';
import { useLang } from '~/stores/i18n';

async function getHostReviews({
  hostId,
  pageParam,
  limit,
  totalReviews,
  lang,
}) {
  const nextLimit = pageParam + 1 * limit;
  const result = await req(
    `${URL_API_HOST}/api/v1/review/host/${hostId}?lang=${lang}&limit=${limit}&from=${pageParam}`,
  ).get();

  return {
    data: result,
    nextCursor: nextLimit >= totalReviews ? undefined : nextLimit,
  };
}

function useHostReviews({ hostId, limit = 3, totalReviews }) {
  const lang = useLang();
  const { data, fetchNextPage, isFetchingNextPage, hasNextPage, isLoading } =
    useInfiniteQuery(
      ['host-reviews', hostId, limit, lang],
      ({ pageParam = 0 }) =>
        getHostReviews({ hostId, pageParam, limit, totalReviews, lang }),
      {
        getNextPageParam: (lastPage) => lastPage.nextCursor,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
      },
    );

  const reviews = useMemo(() => {
    return data?.pages?.flatMap((page) => page.data) || [];
  }, [data]);

  return {
    reviews,
    onLoadMoreReviews: fetchNextPage,
    hasMoreReviews: hasNextPage,
    isLoading: isFetchingNextPage || isLoading,
  };
}

export default useHostReviews;
